import { Component, OnInit } from '@angular/core';
import {MenuBreadCrumb} from 'brainloper-ui';

@Component({
    selector: 'app-indicators-inventory',
    templateUrl: './indicators-inventory.component.html',
    styleUrls: ['./indicators-inventory.component.scss'],
    standalone: false
})
export class IndicatorsInventoryComponent implements OnInit {
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Indicadores Almacen',
      current: true,
    },
  ];

  constructor(
  ) {}

  async ngOnInit() {
  }

}
